module.exports = __webpack_public_path__ + "img/blankProfilePicture.77f5794e.png";